import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import store from '../configureStore';

const axiosInstance = axios.create();

/**
 * Mock configs
 */

const WithMock = (intance, method) => async (...args) => {
  try {
    const validArgs = args.filter((arg) => arg !== null);
    if (validArgs.length < intance.length) {
      throw new TypeError('Argument cannot be null or undefined.');
    }
    const { data, status } = await intance[method](...validArgs);
    return { data, status, error: null };
  } catch (E) {
    return { data: null, error: E };
  }
};

// JSDOC
/**
 * Helper method to get data from anywhere
 *
 * @param {string} method GET|POST|...
 * @param {string} endpoint url to fetch data
 * @param {object} payload request payload object. defaults to empty object
 * @param {object} options override request options (e.g headers)
 *
 * @returns {object} including data and status
 * @author Alireza zbr
 */
// DRY vs WET
const cts = async (method, endpoint, payload = {}, options = {}) => {
  try {
    const { data, status } = await WithMock(axiosInstance, method)(endpoint, payload, options);
    return Promise.resolve({ data, status });
  } catch (e) {
    Bugsnag.leaveBreadcrumb('HTTP Request Failed', {
      method,
      endpoint,
      error: e.message,
      type: 'cts'
    });
    console.warn(`Error sending a reques to ${endpoint}`);
    return null;
  }
};

export const cts_secure = async (method, url, payload = {}) => {
  try {
    const key = store.store.getState().plugin.xgw;
    const headers = {
      ...axios.defaults.headers,
      'x-api-key': key
    };

    const { data, status } = await axios({
      method,
      url,
      headers,
      data: payload
    });

    return Promise.resolve({ data, status });
  } catch (e) {
    Bugsnag.leaveBreadcrumb('Secure HTTP Request Failed', {
      method,
      url,
      error: e.message,
      type: 'cts_secure'
    });
    console.warn(`Error sending a reques to ${url}`);
    return null;
  }
};

export default cts;
